// extracted by mini-css-extract-plugin
export default {"main":"Nav_main__Q0Qug","left":"Nav_left__MBG2a","name":"Nav_name__lUbe9","right":"Nav_right__sMjSU","list":"Nav_list__ggTql"};